import React from 'react';
import { Stack, Box, Divider, Typography } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { getIntervalBetweenRacers, getLastBestColumnColor, getStandingsBestOrLastTime } from './Utils';
import { useTheme } from '@mui/material/styles';

function NearViewDriver({ curDriver, position, referenceDriver, classRacers, raceState }) {
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.down('md')); // < 1000px
    const isSmall = useMediaQuery(theme.breakpoints.down('sm')); // < 600px

    return (
    <Stack direction="column" justifyContent="space-between" alignItems="stretch" spacing={1}>
        {referenceDriver && classRacers && raceState ? (
            <>
                <Stack direction="row" 
                    spacing={2} 
                    divider={<Divider orientation="vertical" flexItem />}
                    justifyContent="space-between"
                    sx={{ flexGrow: 1 }}>
                    <Typography variant="standingsPosition" component="span" align="center" sx={{ width: '5%', backgroundColor: 'secondary.dark', fontSize: '1.5rem' }} >
                        { position }
                    </Typography>
                    <Typography variant="standingsClass" component="span" align="center" noWrap sx={{ width: '8%', backgroundColor: classRacers[referenceDriver.class] ? classRacers[referenceDriver.class].color : "inherit", fontSize: '1.5rem' }} >
                        { referenceDriver.class }
                    </Typography>
                    <Typography noWrap variant="standingsName" sx={{ width: '40%', fontSize: '1.5rem', fontWeight: 600 }}>
                        { referenceDriver.name.toUpperCase() }
                    </Typography>
                    <Typography variant="standingsNumber" component="span" align="center" sx={{ width: '8%', fontSize: '1.5rem' }} >
                        { referenceDriver.number  }
                    </Typography>
                </Stack>
                <Stack 
                    direction="row" 
                    spacing={1} 
                    justifyContent="space-between" 
                    alignItems="center" 
                    divider={<Divider orientation="vertical" flexItem />} 
                    sx={{ flexGrow: 1, overflow: 'hidden' }}
                >
                    <Box sx={{ 
                        flex: 1, 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'flex-start',
                        overflow: 'visible'
                    }}>
                        <Typography 
                            variant="nearTime" 
                            align="left" 
                            sx={{ 
                                width: '100%',
                                whiteSpace: 'nowrap',
                                overflow: 'visible',
                                textOverflow: 'clip',
                                fontSize: {
                                    xs: 'clamp(2.5rem, 8vw, 5.5rem)',
                                    sm: 'clamp(3.5rem, 12vw, 6.5rem)',
                                    md: 'clamp(4.5rem, 14vw, 8.5rem)'
                                },
                                lineHeight: 1.1
                            }}
                        >
                            {getIntervalBetweenRacers(curDriver, referenceDriver)}
                        </Typography>
                    </Box>
                    <Box sx={{ 
                        flex: 1, 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'flex-end',
                        overflow: 'visible'
                    }}>
                        <Typography 
                            variant="nearTime" 
                            align="right" 
                            sx={{ 
                                width: '100%',
                                whiteSpace: 'nowrap',
                                overflow: 'visible',
                                textOverflow: 'clip',
                                color: getLastBestColumnColor(raceState, curDriver, referenceDriver),
                                fontSize: {
                                    xs: 'clamp(2.5rem, 8vw, 5.5rem)',
                                    sm: 'clamp(3.5rem, 12vw, 6.5rem)',
                                    md: 'clamp(4.5rem, 14vw, 8.5rem)'
                                },
                                lineHeight: 1.1
                            }}
                        >
                            {getStandingsBestOrLastTime(raceState, curDriver, referenceDriver)}
                        </Typography>
                    </Box>
                </Stack>
            </>
        ) : (
            <Box sx={{ flexGrow: 1, height: "3rem" }}></Box>
        )}
    </Stack>
    );
};

export default NearViewDriver;

